(() => {
  const root = document.querySelector('[data-editorial-page]');
  if (!root || root.dataset.editorialReady === 'true') return;

  const content = root.querySelector('[data-editorial-content]');
  const toc = root.querySelector('[data-editorial-toc]');
  const list = toc?.querySelector('ol');
  const headings = content ? Array.from(content.querySelectorAll('h2')) : [];

  root.dataset.editorialReady = 'true';

  if (!list || headings.length === 0) {
    if (toc) toc.hidden = true;
    return;
  }

  const usedIds = new Set();

  headings.forEach((heading, index) => {
    let id = heading.id || `section-${index + 1}`;
    while (usedIds.has(id)) id = `${id}-${index + 1}`;
    usedIds.add(id);
    heading.id = id;

    const item = document.createElement('li');
    const link = document.createElement('a');
    const number = document.createElement('span');
    const label = document.createElement('span');

    number.textContent = String(index + 1).padStart(2, '0');
    label.textContent = heading.textContent.trim();
    link.href = `#${id}`;
    link.append(number, label);
    item.append(link);
    list.append(item);
  });

  if (!('IntersectionObserver' in window)) return;

  const links = Array.from(list.querySelectorAll('a'));
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      links.forEach((link) => link.removeAttribute('aria-current'));
      const active = list.querySelector(`a[href="#${CSS.escape(entry.target.id)}"]`);
      if (active) active.setAttribute('aria-current', 'location');
    });
  }, { rootMargin: '-18% 0px -72% 0px' });

  headings.forEach((heading) => observer.observe(heading));
})();
